import { useState, useEffect } from "react"
import { Grid, Icon, IconButton } from "@mui/material"
import { useDispatch, useSelector } from "react-redux";
import { Select, Tooltip } from "@gpstrackit/react-controls";
import { useIntl } from "react-intl";

//Components
import { SidePanel, Button } from "@gpstrackit/react-controls";
import CustomSelect from 'Components/Select';
import { DateRangePicker } from "@gpstrackit/gtc-react-controls";
import moment from 'moment';

import {
    searchEntityRequest,
    clearRedux,
} from "Redux/actions";

//Actions
import { getAccounts } from 'Modules/activities/views/main/redux/saga';

import { HasPermission } from 'Core/security'
import { getTransactionsTypesOptions, getProcessingStatusOptions } from "Core/data/Helpers"

const AdvancedFilters = (props) => {
    const { openPanel, setOpenPanel, tableRef, setAccount, account, type, setType, status, setStatus, startDate, setStartDate, endDate, setEndDate } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    //Redux States
    const loadingKeyFobs = useSelector(state => state.commonRedux.loadingDataView);
    const user = useSelector(state => state.securityRedux.user);

    const { loadingAccounts } = useSelector(state => state.activitiesMainRedux.loadingAccounts)

    //Local States
    const [conditions, setConditions] = useState(tableRef?.current?.conditions || []);

    const handleApply = () => {
        tableRef?.current?.getData({ newConditions: conditions });
    }

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    useEffect(() => {
        if (openPanel) setConditions(tableRef?.current?.conditions || [])
        else setConditions([]);
    }, [openPanel]);

    return (
        <SidePanel
            isOpen={openPanel}
            toggle={() => setOpenPanel(!openPanel)}
            sidePanelButtonStyle={(account || type || status || startDate) ? "side-panel-button" : "side-panel-button-white"}
        >
            <Grid
                container
                direction='row'
                justifyContent='space-between'
                alignItems='center'
            >
                <Grid item xs={8}>
                    <label style={{ fontSize: 'large', fontWeight: 500 }}>{messages['accounts_main_advanced_filters']}</label>
                </Grid>
                <Grid item xs={4} style={{ display: 'flex', justifyContent: 'end' }}>
                    <Tooltip title={messages['accounts_main_remove_filters']}>
                        <IconButton
                            onClick={() => {
                                setAccount(null);
                                setType(null);
                                setStatus(null);
                                setStartDate(null);
                                setEndDate(null);

                                let currentConditions = conditions;

                                let deleteAccount = currentConditions.findIndex((item) => item.fields[0] === 'companyId');
                                deleteAccount >= 0 && currentConditions.splice(deleteAccount, 1);

                                let type = currentConditions.findIndex((item) => item.fields[0] === 'transactionType');
                                type >= 0 && currentConditions.splice(type, 1);

                                let status = currentConditions.findIndex((item) => item.fields[0] === 'processingStatus');
                                status >= 0 && currentConditions.splice(status, 1);

                                let range = currentConditions.findIndex((item) => item?.range);
                                range >= 0 && currentConditions.splice(range, 1);

                                setConditions(currentConditions);

                                tableRef?.current?.getData({ newConditions: currentConditions });

                            }}
                            size="large">
                            <Icon>delete</Icon>
                        </IconButton>
                    </Tooltip>

                </Grid>
                <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                    <Button
                        className="btn btn-dark-blue btn-block"
                        onClick={(e) => {
                            e.preventDefault();
                            handleApply();
                        }}
                        disabled={loadingKeyFobs}
                    >
                        {messages['accounts_main_apply']}
                    </Button>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    <CustomSelect
                        async
                        value={account}
                        onChange={(item) => {

                            let currentConditions = conditions.length === 0 ? tableRef?.current?.conditions : conditions;
                            let newConditions = currentConditions.filter((item) => item.fields[0] !== 'companyId');

                            setAccount(item);
                            if (item) newConditions.push({ fields: ["companyId"], terms: [item?.id], exact: true, conditionOperator: "AND" })

                            setConditions(newConditions);
                        }}
                        label={messages['keyfobs_main_account']}
                        loadOptions={getAccountsForSelect}
                        loading={loadingAccounts}
                        getOptionLabel={e => e.name}
                        getOptionValue={e => e.id}
                    />
                </Grid>

                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['transactions_requests_date_range']}</label>
                    <div style={{ position: 'relative' }}>
                        <DateRangePicker
                            key={startDate || 'empty'}
                            calendarPosition="bottom-end"
                            className=""
                            startDate={startDate}
                            endDate={endDate}
                            format="MMM DD, YYYY"
                            maxDate={moment.now()}
                            minDate={moment().add(-1, 'years')}
                            onChange={(start, end) => {

                                setStartDate(start);
                                setEndDate(end);

                                let currentConditions = conditions.length === 0 ? tableRef?.current?.conditions : conditions;
                                let newConditions = currentConditions.filter((item) => !item.range);

                                if (start && end) {
                                    newConditions.push({
                                        fields: [], terms: [],
                                        range: {
                                            fields: ["createdOn"],
                                            GTE: moment(moment(start).format("YYYY-MM-DD") + " 00:00:00").utc().format("YYYY-MM-DDTHH:mm:ss.sss") + "Z",
                                            LTE: moment(moment(end).format("YYYY-MM-DD") + " 23:59:59").utc().format("YYYY-MM-DDTHH:mm:ss.sss") + "Z"
                                        },
                                        exact: true, conditionOperator: "AND"
                                    })
                                }
                                tableRef?.current?.getData({ newConditions: newConditions, filters: { filterValidation: false } });
                                setConditions(newConditions);

                            }}
                            orientation="horizontal"
                            style={{
                                width: '100%'
                            }}
                            showButtons={true}
                        />
                        {!startDate && (
                            <div style={{
                                position: 'absolute',
                                top: '1px',
                                left: '1px',
                                right: '32px',
                                height: '34px',
                                pointerEvents: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                paddingLeft: '9px',
                                backgroundColor: 'white',
                                borderRadius: '3px',
                                color: '#909090',
                                fontSize: '13px',
                                zIndex: 1,
                            }}>
                                {messages['transactions_requests_date_range']}
                            </div>
                        )}
                    </div>
                </Grid>

                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    {
                        <div>
                            <Select
                                id="transaction-request-type-id"
                                valueField="id"
                                textField="label"
                                value={getTransactionsTypesOptions(messages).find(x => x.id === type)}
                                label={messages['transactions_requests_type']}
                                placeholder={messages['transactions_requests_type']}
                                options={getTransactionsTypesOptions(messages) || []}
                                onChange={(type) => {
                                    setType(type ? type?.id : null);
                                    let currentConditions = conditions.length === 0 ? tableRef?.current?.conditions : conditions;
                                    let newConditions = currentConditions.filter((item) => item.fields[0] !== 'transactionType');

                                    if (type) {
                                        newConditions.push({ fields: ["transactionType"], terms: type.id === "ReprocessOdoHrs" ? type.values : [`${type.id}`], exact: true, conditionOperator: "AND" })
                                    }
                                    tableRef?.current?.getData({ newConditions: newConditions, filters: { filterValidation: false } });
                                    setConditions(newConditions);
                                }}
                                requiredMessage={messages['required_field']}
                                isClearable
                            />
                        </div>
                    }
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    {
                        <div>
                            <Select
                                id="change-status-id"
                                valueField="id"
                                textField="label"
                                value={getProcessingStatusOptions(messages).find(x => x.id === status)}
                                label={messages['transactions_requests_processing_status']}
                                placeholder={messages['transactions_requests_processing_status']}
                                options={getProcessingStatusOptions(messages) || []}
                                onChange={(status) => {
                                    setStatus(status ? status.id : null);
                                    let currentConditions = conditions.length === 0 ? tableRef?.current?.conditions : conditions;
                                    let newConditions = currentConditions.filter((item) => item.fields[0] !== 'processingStatus');

                                    if (status) {
                                        newConditions.push({ fields: ["processingStatus"], terms: [`${status.id}`], exact: true, conditionOperator: "AND" })
                                    }
                                    tableRef?.current?.getData({ newConditions: newConditions, filters: { filterValidation: false } });
                                    setConditions(newConditions);
                                }}
                                requiredMessage={messages['required_field']}
                                isClearable
                            />
                        </div>
                    }
                </Grid>

            </Grid>
        </SidePanel>
    );
}
export default AdvancedFilters